// extracted by mini-css-extract-plugin
export default {"header":"TopRequestors_header__T7RI1","list":"TopRequestors_list__RvhfG","title":"TopRequestors_title__VHMZB","value":"TopRequestors_value__ZIOmX","item":"TopRequestors_item__66fK7"};